import {SET_EDITING_MOBILE} from './constants';

export interface SetEditingMobileAction {
  type: typeof SET_EDITING_MOBILE;
  payload: {
    editingMobile: boolean;
  };
}

export type FabricDesignAction = SetEditingMobileAction;

export const setEditingMobile = (editingMobile: boolean): SetEditingMobileAction => ({
  type: SET_EDITING_MOBILE,
  payload: {
    editingMobile,
  },
});
